import httpClient from './api/httpClient';

const END_POINT = 'contato';
export const getOne = () => httpClient.get (END_POINT + '/');
export const create = (contato) => {
    let contatoForm = {
        telefone: contato.telefone,
        email: contato.email,
        contato_urgencia: contato.contato_urgencia,
    };
    return httpClient.post(END_POINT, contatoForm);
}